const { round } = require('lodash');

class RatingController {
    constructor(ratingService, analyticsService) {
        this.ratingService = ratingService;
        this.analyticsService = analyticsService;
    }

    $onInit() {
        this.average = round(this.rating.Average, 1).toFixed(1);
        this.stars = this.ratingService.populateStars(this.average);
    }

    onRatingClickEvent() {
        this.onRatingClick();
    }
}

RatingController.$inject = ['RatingService', 'AnalyticsService'];

const ratingComponentDefinition = {
    controller: RatingController,
    template: require('./rating.component.html').trim(),
    bindings: {
        rating: '<',
        shouldShowTotal: '<?',
        onRatingClick: '&',
    },
};

module.exports = {
    RatingController,
    ratingComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/rating/rating.component.js